import { SelectOptionType } from "src/extension-views/video-component/components/ui/Select";
import { BitsProduct } from "twitch-ext";

export const portBitsProductToSelectOption = (product: BitsProduct): SelectOptionType => {
  return {
    label: product.displayName,
    value: product.sku,
  };
};
